// import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const PREFIX = '_empty';

const classes = {
  content: `${PREFIX}-content`,
};

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  color: '#888888',
  backgroundColor: '#f1f1f1',
  borderRadius: 2,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  padding: theme.spacing(4),
  textAlign: 'center',
  [`& .${classes.content}`]: {
  },
}));

interface IProps {
  title: string;
  children?: JSX.Element;
}

export default function Empty(props: IProps): JSX.Element {
  const { title, children } = props;
  return (
    <Root>
      <Typography
        variant="body1"
        gutterBottom
        sx={{ fontWeight: 'regular' }}
      >
        {title}
      </Typography>
      {children && (
        <div className={classes.content}>
          {children}
        </div>
      )}
    </Root>
  );
}

